export const comercialPropertyTypes = [
  'Campo',
  'Depósito',
  'Edificio Comercial',
  'Edificio de oficinas',
  'Galpón',
  'Galpon',
  'Hotel',
  'Local',
  'Oficina',
  'Terreno',
  'Nave Industrial',
  'Fondo de Comercio',
]

export const residencialPropertyTypes = [
  'Departamento',
  'Casa',
  'Edificio',
  'Terreno',
  'Quinta',
  'PH',
  'Cochera',
]

export const emprendimientosPropertyTypes = [
  'Edificio de oficinas',
  'Edificio',
  'Country',
  'Barrio Privado',
  'Nautico',
  'Rural',
  'Edificio de Cocheras',
  'Condominio Industrial',
  'Centro Logístico',
  'Condominio',
  'Otro',
  'Comercial',
  'Hotel',
  'Barrio Abierto',
]

export const landOptionsKeys = {
  mixto: 'Mixto',
  comercial: 'Comercial',
  industrial: 'Industrial',
  residencial: 'Residencial',
}



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/SearchBar.constants.js